import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../shared/material.module";
import { UiModule } from "../ui/ui.module";
import { AvatarComponent } from "./default-layout/avatar/avatar.component";
import { DefaultLayoutComponent } from "./default-layout/default-layout.component";
import { HeaderComponent } from "./default-layout/header/header.component";
import { ForgotPasswordLayoutComponent } from "./forgot-password-layout/forgot-password-layout.component";
import { LoginLayoutComponent } from "./login-layout/login-layout.component";

@NgModule({
	declarations: [
		DefaultLayoutComponent,
		HeaderComponent,
		AvatarComponent,
		LoginLayoutComponent,
		ForgotPasswordLayoutComponent
	],
	imports: [CommonModule, RouterModule, MaterialModule, UiModule]
})
export class ContainersModule {}
